<template>
  <span v-if="isAuthorised" class="ml-auto">
    <v-chip
      class="ma-2 elevation-8"
      color="secondary"
      :disabled="!isValid"
      @click="dialog = true"
    >
      <v-icon>{{ icons.mdiClockOutline }}</v-icon>
      <span class="ml-4">{{ caption }}</span>
    </v-chip>
    <DynamicCronJobDialog
      :closeDialogBox="dialog"
      :presetDestination="destination"
      :presetParams="params"
      baseCrudKey="addToCronJobBtn"
      :rowItem.sync="cronJobItem"
      @settingDialogVal="dialog = $event"
    />
  </span>
</template>

<script>
import { mapGetters } from 'vuex';
import { mdiClockOutline } from '@mdi/js';
import DynamicCronJobDialog from '../import/DynamicCronJobDialog.vue';

export default {
  name: 'AddToCronJobBtn',
  components: { DynamicCronJobDialog },
  props: {
    destination: { type: String, required: true },
    params: { type: Object, default: () => ({}) },
    caption: { type: String, default: 'Add to Cron Job' },
    isValid: { type: Boolean, default: true },
  },
  computed: {
    ...mapGetters('auth/token', ['authUserRoles', 'isTaxAdminAccessible']),
    isAuthorised() {
      return (this.authUserRoles || []).includes('TmcSupport') || this.isTaxAdminAccessible;
    },
  },
  data() {
    return {
      dialog: false,
      icons: { mdiClockOutline },
      cronJobItem: {
        description: '',
        destination: '',
        params: {},
        expectedRunTime: {
          frequency: 'weekly', days: '*', monthDay: 'LW', hrs: 0, mins: 0, secs: 0,
        },
        isActiveInactive: true,
      },
    };
  },
  created() {
    this.$store.dispatch('cron/cronJobUtil/getReportRoutes');
  },
};
</script>
